import {ChangeDetectorRef, Component, Input, OnInit, Renderer2, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {CustomFormControl} from '../CustomFormControl';
import {FileSizePipe} from '../../../../../_pipes/fileSize.pipe';

@Component({
    selector: 'app-file-upload-v2',
    templateUrl: './file-upload-v2.component.html',
    styleUrls: ['./file-upload-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FileUploadV2Component implements OnInit {

  isDraggedOver = false;

  @Input() fileControl!: CustomFormControl;
  @ViewChild('fileInput') fileInput: any;

  constructor(private renderer: Renderer2,
              private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  onFileSelected(event: any): void {
    const files: FileList = event.target.files;
    this.addFiles(files);
    this.renderer.setProperty(this.fileInput.nativeElement, 'value', '');
  }

  onDragOver(event: any): void {
    event.preventDefault();
    this.isDraggedOver = true;
  }

  onDragLeave(event: any): void {
    event.preventDefault();
    this.isDraggedOver = false;
  }

  onDrop(event: any): void {
    event.preventDefault();
    this.isDraggedOver = false;
    const files = event.dataTransfer.files;
    this.addFiles(files);
  }

  addFiles(files: FileList): void {
    const fileErrors: string[] = [];

   
    for (let i = 0; i < files.length; i++) {
      this.addFile(files[i], fileErrors);
    }

    this.fileControl.element.fileErrors = fileErrors;
    this.cd.detectChanges();
  }

  addFile(file: File, fileErrors: string[]): void {
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const element = this.fileControl.element;
    const numErrorsBefore = fileErrors.length;

    if (!element.allowedExtensions.has(fileExtension)) {
      fileErrors.push(`${file.name} has a disallowed extension`);
    }

    if (element.uniqueFiles.has(file.name)) {
      fileErrors.push(`\"${file.name}\" has already been uploaded.`);
    }

    if (element.files.length + 1 > element.maxFiles) {
      fileErrors.push(`Cannot add \"${file.name}\" as you have reached the maximum number of files.`);
    }

    if (element.totalFileSize + file.size > element.maxTotalSize) {
      fileErrors.push(`Cannot add \"${file.name}\" as you have reached the maximum cumulative file upload limit.`);
    }

    if (file.size > element.maxIndividualFileSize) {
      fileErrors.push(`Cannot add \"${file.name}\" as an individual file size cannot exceed ${new FileSizePipe().transform(element.maxIndividualFileSize)}`);
    }

    if (file.name.length > 60) {
      fileErrors.push(`Cannot add \"${file.name}\" because the name exceeds 60 characters. Please rename the file and try again.`);
    }

    if (file.size === 0) {
      fileErrors.push(`Cannot add \"${file.name}\" because the file appears to be empty.`);
    }

    if (fileErrors.length > numErrorsBefore) {
      return;
    }

    element.files.push(file);
    element.totalFileSize += file.size;
    element.uniqueFiles.add(file.name);
  }

  deleteFile(file: File): void {
    this.fileControl.element.uniqueFiles.delete(file.name);

    const index = this.fileControl.element.files.indexOf(file);
    if (index !== -1) {
      this.fileControl.element.totalFileSize -= file.size;
      this.fileControl.element.files.splice(index, 1);
    }
  }

}
